import React from "react";

const DropdownUnselectIcon = (props) => {
  return (
    <div onClick={props.unselectRadiologist}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M5.59142 6.26866L0 0.677239L0.677239 0L5.59142 4.91418L10.5056 0L11.1828 0.677239L5.59142 6.26866Z"
          fill="#C8C6C4"
        />
        <path
          d="M5.59144 5.73134L11.1829 11.3228L10.5056 12L5.59144 7.08582L0.677264 12L2.57492e-05 11.3228L5.59144 5.73134Z"
          fill="#C8C6C4"
        />
      </svg>
    </div>
  );
};

export default DropdownUnselectIcon;
